export default function Card() {
  return (
    <>
      <path
        d="M221.117 112.137L223.322 97.0658L225.793 111.559L221.408 68.5969L224.187 43.9189L220.036 10.0285C219.944 6.17345 217.136 0.807831 213.766 0.88787L192.287 2.93639L206.558 0.70399L113.563 5.22005L107.291 0.753557L40.2929 6.19074L7.33064 6.20058C3.96013 6.28062 1.39936 11.0081 1.49091 14.8632L0.980702 78.6489L3.34899 93.1089L8.43812 109.428L4.01032 120.958L8.29492 131.77L8.52095 141.288L12.0311 158.96L60.3074 154.055L131.63 156.204L206.51 150.583L220.34 154.368L222.977 133.906L221.117 112.137Z"
        fill="url(#paint0_linear_139_641)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_139_641"
          x1="109.52"
          y1="156"
          x2="107.5"
          y2="-2"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B1B78" />
          <stop offset="1" stopColor="#2946C7" />
        </linearGradient>
      </defs>
    </>
  );
}
